import { cn } from '@repo/tailwind-config/tailwind.functions'
import { tailwindColors } from '@repo/tailwind-config/tailwind.vars'
import { useBreakPoint } from '@repo/toolkit/use-break-point'
import { LoginGroupFiveIcon, Logo } from '@repo/ui/icons'
import Typography from '@repo/ui/typography'

import useTranslate from '../../../lib/hooks/use-translate'

const StaffAuthVariant = () => {
  const device = useBreakPoint()
  const isMobile = device === 'mobile'
  const { t } = useTranslate()
  return (
    <div className="w-full h-full bg-cover bg-center bg-no-repeat mobile:bg-[url('/staff-login.png')] bg-[url('/staff-login.png')]">
      <div className="flex flex-col items-end w-fit pt-20">
        <div className="flex flex-col items-start w-fit mobile:mx-6">
          <Logo text="Séjours Linguistiques" className={cn('w-28 h-28 mobile:w-20 mobile:h-20')} />
          {isMobile && (
            <Typography variant="h3" color={tailwindColors.white.DEFAULT}>
              {t('staff.personal.space.welcome')}
            </Typography>
          )}
        </div>
        {!isMobile && (
          <LoginGroupFiveIcon color={tailwindColors.white.DEFAULT} className="-ml-1" />
        )}
      </div>
      {!isMobile && (
        <Typography
          variant="h2"
          color={tailwindColors.white.DEFAULT}
          className="w-2/3 text-left mx-auto mt-20 ml-20"
        >
          {t('staff.personal.space.welcome')}
        </Typography>
      )}
    </div>
  )
}

export default StaffAuthVariant
